import React, {useEffect, useState} from "react";
import {Autocomplete, Box, Button, FormControl, FormGroup, Grid, TextField, InputLabel, MenuItem, Select} from "@mui/material";
import {DateTimePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {useGetGuidMapTohQuery} from "../../../core/api/toh-charge-api";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutlined';

const emptyOption = {guid: '', displayName: ''};

export default function Guid2Block(props) {
    const [stringArgs, setStringArgs] = useState("")
    const [supportId, setSupportId] = useState("")
    const [duration, setDuration] = useState("")
    const [mephistoTag, setMephistoTag] = useState("")
    const [amount, setAmount] = useState("")
    const [guid2, setGuid2] = useState(null)
    const [endTime, setEndTime] = useState(null)
    const [guid, setGuid] = useState(null)
    const [type, setType] = useState(props.selectedItem?.value || '')

    const {
        data: guidMap,
    } = useGetGuidMapTohQuery()

    const getVisibleFieldsCount = () => {
        const item = props.selectedITemList[props.index].item;
        let count = 1;
        if (item.guidMap !== null && item.guidMap !== "") count++;
        if (item.guidMap2 !== null && item.guidMap2 !== "") count++;
        if (item.amount === true) count++;
        if (item.stringArgs === true) count++;
        if (item.supportId === true) count++;
        if (item.duration === true) count++;
        if (item.endTime === true) count++;
        return count;
    }

    const getFieldWidth = () => {
        const count = getVisibleFieldsCount();
        return 12 / Math.min(count, 6);
    }

    // --- Warning / highlight helpers ---

    const isFieldEmpty = (field) => {
        const currentItem = props.selectedITemList[props.index];
        switch (field) {
            case 'guid':
                return currentItem.item.guidMap !== "" && !currentItem.guid?.guid;
            case 'guid2':
                return currentItem.item.guidMap2 !== "" && !guid2?.guid;
            case 'amount':
                return currentItem.item.amount === true &&
                    (amount === "" || amount === "0" || Number(amount) === 0);
            case 'endTime':
                return currentItem.item.endTime === true && !endTime;
            default:
                return false;
        }
    }

    const warningStyle = (field) => isFieldEmpty(field) ? {
   
    } : {}

    const autocompleteWarningStyle = (field) => isFieldEmpty(field) ? {
    } : {}

    // ---

    useEffect(() => {
        const current = props.selectedITemList[props.index];

        if (props.resetData) {
            if (guid !== null) setGuid(null);
            if (guid2 !== null) setGuid2(null);
        } else {
            if (current.guid && current.guid !== guid) {
                setGuid(current.guid);
            }
            if (current.guid2 && current.guid2 !== guid2) {
                setGuid2(current.guid2);
            }
            if (current.endTime && current.endTime !== endTime) {
                setEndTime(current.endTime);
            }
            if (typeof current.amount !== "undefined" && String(current.amount) !== amount) {
                if (current.item?.amountAttribute === "seconds") {
                    setAmount(String(current.amount / 3600));
                } else {
                    setAmount(String(current.amount));
                }
            }
            if (typeof current.stringArgs !== "undefined" && current.stringArgs !== stringArgs) {
                setStringArgs(current.stringArgs);
            }
            if (typeof current.supportId !== "undefined" && current.supportId !== supportId) {
                setSupportId(current.supportId);
            }
            if (typeof current.mephistoTag !== "undefined" && current.mephistoTag !== mephistoTag) {
                setMephistoTag(current.mephistoTag);
            }
            if (typeof current.duration !== "undefined" && current.duration !== duration) {
                setDuration(current.duration);
            }
        }

        let newValidateChildrenList = [...props.validateChildrenList];
        newValidateChildrenList[props.index] = !checkChargeButtonDisable();
        props.setValidateChildrenList(newValidateChildrenList);

    }, [guid, guid2, props.selectedITemList[props.index]])

    const checkChargeButtonDisable = () => {
        return (
            ((props.selectedITemList[props.index]["item"].guidMap2 !== "") && guid2 == null) ||
            !props.selectedITemList[props.index]["item"].value
        )
    }

    const handleChangeAmount = (event) => {
        const newAmount = event.target.value;

        if (props.selectedITemList[props.index]["item"].value === 'OffsetBattleAutoLevel' && newAmount > 0) {
            return;
        }

        setAmount(newAmount);

        const numericValue = newAmount === ""
            ? ""
            : (props.selectedITemList[props.index]["item"].amountAttribute === 'seconds'
                ? newAmount * 3600
                : newAmount);

        updateItemInList("amount", numericValue);
    }

    const handleChangeStringArgs = (event) => {
        setStringArgs(event.target.value)
        updateItemInList("stringArgs", event.target.value);
    }
    const handleChangeSupportId = (event) => {
        setSupportId(event.target.value)
        updateItemInList("supportId", event.target.value);
    }
    const handleChangeMephistoTag = (event) => {
        setMephistoTag(event.target.value)
        updateItemInList("mephistoTag", event.target.value);
    }
    const handleChangeDuration = (event) => {
        setDuration(event.target.value)
        updateItemInList("duration", event.target.value);
    }

    const handleChangeType = (event) => {
        const selectedType = event.target.value;
        setType(selectedType);

        const selectedChargeType = selectedType
            ? props.chargeTypes.find(item => item.name === selectedType)
            : {value: '', guidMap: '', guidMap2: ''};

        let newItem = {
            ...props.selectedITemList[props.index],
            "item": selectedChargeType
        };

        setGuid(null);
        setGuid2(null);

        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList[props.index] = newItem;
        props.setSelectedItemList(newSelectedItemList);
    }

    const handleChangeItem2 = (event, values) => {
        props.setResetData(false)
        const selected = values?.guid === '' ? null : values;
        setGuid2(selected)
        updateItemInList("guid2", selected);
    }

    const updateItemInList = (field, value) => {
        let newItem = {...props.selectedITemList[props.index], [field]: value};
        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList[props.index] = newItem;
        props.setSelectedItemList(newSelectedItemList);
    }

    const handleChangeItem = (event, values) => {
        props.setResetData(false)
        const selected = values?.guid === '' ? null : values;
        setGuid(selected)

        let newItem = {
            ...props.selectedITemList[props.index],
            "guid": selected,
            // не сбрасываем amount при смене guid
        };

        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList[props.index] = newItem;
        props.setSelectedItemList(newSelectedItemList);
    }

    const handleAddItem = () => {
        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList.push({"item": {"value": "", "guidMap": "", "guidMap2": ""}});
        props.setSelectedItemList(newSelectedItemList)
    }

    const handleRemoveItem = () => {
        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList.splice(props.index, 1);
        props.setSelectedItemList(newSelectedItemList)

        let newValidateChildrenList = [...props.validateChildrenList];
        newValidateChildrenList.splice(props.index, 1);
        props.setValidateChildrenList(newValidateChildrenList);
    }

    const handleSetTime = (value) => {
        setEndTime(value)
        updateItemInList("endTime", value);
    }

    const fieldWidth = getFieldWidth();

    const getMephistoTagSelector = (selectedItem) => {
        const selectInput = <TextField
            fullWidth
            variant="outlined"
            value={selectedItem.mephistoTag || ""}
            label="Mephisto Tag"
            onChange={handleChangeMephistoTag}
        />

        const mephistoTags = selectedItem.item.mephistoTag
        if (mephistoTags === "") return selectInput
        try {
            const tags = mephistoTags.split(',')
            return <FormControl fullWidth>
                <InputLabel>Mephisto Tag</InputLabel>
                <Select
                    value={selectedItem.mephistoTag || ""}
                    label="Mephisto Tag"
                    onChange={handleChangeMephistoTag}
                >
                    {tags.map(item => (
                        <MenuItem key={item} value={item}>{item}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        } catch (e) {
            return selectInput
        }
    }

    const guidOptions = guidMap && props.selectedITemList[props.index].item.guidMap &&
    guidMap.hasOwnProperty(props.selectedITemList[props.index].item.guidMap)
        ? [emptyOption, ...guidMap[props.selectedITemList[props.index].item.guidMap]]
        : [emptyOption];

    const guid2Options = guidMap && props.selectedITemList[props.index].item.guidMap2 &&
    guidMap.hasOwnProperty(props.selectedITemList[props.index].item.guidMap2)
        ? [emptyOption, ...guidMap[props.selectedITemList[props.index].item.guidMap2]]
        : [emptyOption];

    return (
        <Box sx={{mb: 3}}>
            <Grid container spacing={2} sx={{
                alignItems: "center"
            }}>

                {/* Type Selection */}
                <Grid size={{xs: fieldWidth}}>
                    <FormControl fullWidth>
                        <InputLabel id={`type-select-label-${props.index}`}>Type</InputLabel>
                        <Select
                            value={props.selectedITemList[props.index].item.value ?? ''}
                            label="Type"
                            onChange={handleChangeType}
                        >
                            <MenuItem value=""><em>—</em></MenuItem>
                            {props.chargeTypes && props.chargeTypes.map((item) => (
                                <MenuItem key={item.name} value={item.name}>{item.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                {/* GUID Selection */}
                {(guidMap && props.selectedITemList[props.index].item.guidMap != null &&
                    props.selectedITemList[props.index].item.guidMap !== "" &&
                    guidMap.hasOwnProperty(props.selectedITemList[props.index].item.guidMap)) && (
                    <Grid size={{xs: fieldWidth}}>
                        <Autocomplete
                            disablePortal
                            id={`guid-select-${props.index}`}
                            options={guidOptions}
                            getOptionLabel={(item) => item?.displayName || ""}
                            isOptionEqualToValue={(option, value) => option?.guid === value?.guid}
                            value={props.selectedITemList[props.index].guid || emptyOption}
                            onChange={handleChangeItem}
                            sx={autocompleteWarningStyle('guid')}
                            renderOption={(props, option) => (
                                <li {...props} key={option.guid || '__empty__'}>
                                    {option.displayName || <em>—</em>}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={props.selectedITemList[props.index].item.guidMap}
                                    color={isFieldEmpty('guid') ? 'warning' : 'primary'}
                                />
                            )}
                        />
                    </Grid>
                )}

                {/* GUID2 Selection */}
                {props.selectedITemList[props.index].item &&
                    (props.selectedITemList[props.index].item.guidMap2 != null &&
                        props.selectedITemList[props.index].item.guidMap2 !== "" &&
                        guidMap && guidMap.hasOwnProperty(props.selectedITemList[props.index].item.guidMap2)) && (
                        <Grid size={{xs: fieldWidth}}>
                            <Autocomplete
                                disablePortal
                                id={`guid2-select-${props.index}`}
                                options={guid2Options}
                                getOptionLabel={(item) => item?.displayName || ""}
                                isOptionEqualToValue={(option, value) => option?.guid === value?.guid}
                                value={guid2 || emptyOption}
                                onChange={handleChangeItem2}
                                sx={autocompleteWarningStyle('guid2')}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.guid || '__empty__'}>
                                        {option.displayName || <em>—</em>}
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={props.selectedITemList[props.index].item.guidMap2}
                                        color={isFieldEmpty('guid2') ? 'warning' : 'primary'}
                                    />
                                )}
                            />
                        </Grid>
                    )}

                {/* Amount Field */}
                {props.selectedITemList[props.index].item.amount === true && (
                    <Grid size={{xs: fieldWidth}}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            value={amount}
                            label={props.selectedITemList[props.index]["item"].amountAttribute === 'seconds' ?
                                "Hours" :
                                (props.selectedITemList[props.index]["item"].amountAttribute || "Amount")}
                            onChange={handleChangeAmount}
                            type="number"
                            sx={warningStyle('amount')}
                            color={isFieldEmpty('amount') ? 'warning' : 'primary'}
                            InputProps={{
                                inputProps: {
                                    min: props.selectedITemList[props.index]["item"].value === 'OffsetBattleAutoLevel' ? undefined : 0,
                                    max: props.selectedITemList[props.index]["item"].value === 'OffsetBattleAutoLevel' ? 0 : undefined,
                                    step: props.selectedITemList[props.index]["item"].amountAttribute === 'seconds' ? 0.1 : 1
                                }
                            }}
                        />
                    </Grid>
                )}

                {/* StringArgs Field */}
                {props.selectedITemList[props.index].item.stringArgs === "true" && (
                    <Grid size={{xs: fieldWidth}}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            value={props.selectedITemList[props.index].stringArgs || ""}
                            label="StringArgs"
                            onChange={handleChangeStringArgs}
                        />
                    </Grid>
                )}

                {/* SupportId Field */}
                {props.selectedITemList[props.index].item.supportId === "true" && (
                    <Grid size={{xs: fieldWidth}}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            value={props.selectedITemList[props.index].supportId || ""}
                            label="supportId"
                            onChange={handleChangeSupportId}
                        />
                    </Grid>
                )}

                {/* Duration Field */}
                {props.selectedITemList[props.index].item.duration === "true" && (
                    <Grid size={{xs: fieldWidth}}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            value={props.selectedITemList[props.index].duration || ""}
                            label="duration"
                            onChange={handleChangeDuration}
                        />
                    </Grid>
                )}

                {/* MephistoTag Field */}
                {props.selectedITemList[props.index].item.mephistoTag != undefined &&
                    props.selectedITemList[props.index].item.mephistoTag.length > 0 && (
                        <Grid size={{xs: fieldWidth}}>
                            {getMephistoTagSelector(props.selectedITemList[props.index])}
                        </Grid>
                    )}

                {/* EndTime Picker */}
                {props.selectedITemList[props.index].item.endTime === true && (
                    <Grid size={{xs: fieldWidth}}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                label="End Time"
                                value={endTime}
                                onChange={(newValue) => handleSetTime(newValue)}
                                format={'DD/MM/YYYY HH:mm'}
                                sx={warningStyle('endTime')}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        variant: "outlined",
                                        color: isFieldEmpty('endTime') ? 'warning' : 'primary',
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                )}
            </Grid>
            {/* Action Buttons (hidden in single mode — one charge item, used by the mass-charge item picker) */}
            {!props.single && <Grid container spacing={1} sx={{mt: 1}}>
                {(props.index !== 0 || (props.index === 0 && props.selectedITemList.length > 1)) && (
                    <Grid>
                        <Button
                            variant="outlined"
                            startIcon={<DeleteIcon/>}
                            color={"error"}
                            onClick={handleRemoveItem}
                        >
                            Remove
                        </Button>
                    </Grid>
                )}

                {props.index === props.selectedITemList.length - 1 && (
                    <Grid>
                        <Button
                            startIcon={<AddCircleOutlineIcon/>}
                            variant="outlined"
                            color="info"
                            onClick={handleAddItem}
                        >
                            Add
                        </Button>
                    </Grid>
                )}
            </Grid>}
        </Box>
    );
}